define(function(require, exports, module) {
    'use strict';
    var device = require('util/device.util');
    var config = require('config');
    var PopupView = require('modules/popup/popup.view');

    module.exports = PopupView.extend({
        closeByTapOnOverlay: function() {
            var lossLimitPage = config.get('lossLimitPage') || '/loss-limit';
            var isLossLimitPage = location.pathname.includes(lossLimitPage);
            var isOverlay = document.activeElement.matches('body');

            if(isLossLimitPage) {
                return;
            }

            return isOverlay && PopupView.prototype.closeByTapOnOverlay.apply(this, arguments);
        },

        redraw: function(el) {
            if (device.os === 'android' && device.isKeyboardPresent) {
                return window.getComputedStyle(el);
            }

            PopupView.prototype.redraw.apply(this, arguments);
        }
    });
});
